import { Controller } from "@hotwired/stimulus";

// Clears a field row's server-rendered validation state on the first edit. Wrap a field row
// (label + control + message) and route its input/change events to #clear.
//
//   <div data-controller="ui--clear-field-error"
//        data-action="input->ui--clear-field-error#clear change->ui--clear-field-error#clear">
//     <label class="error">…</label>
//     <input class="… error">
//     <p data-ui--clear-field-error-target="message">Can't be blank</p>
//   </div>
export default class extends Controller {
  static targets = ["message"];

  clear() {
    this.element.querySelectorAll(".error").forEach((el) => el.classList.remove("error"));
    // The one control styled without the shared class (a native <select>) paints its own border.
    this.element.querySelectorAll(".border-red-400").forEach((el) => el.classList.remove("border-red-400"));
    this.messageTargets.forEach((message) => message.remove());
  }
}
